export const locales = {
    'en-us': {
        progressbar_progress: 'Your Progress',
        progressbar_complete: 'Complete',
    },
    'es-us': {
        progressbar_progress: 'Su progreso',
        progressbar_complete: 'Completa',
    },
};
//# sourceMappingURL=locales.js.map